module.exports = __webpack_public_path__ + "media/images/icons/outlined/switcher-44063a110973370ad0e9b3bf5ad6ea02.svg";